import { customerApi } from "../../utils/apiConfig";

const getAuthHeaders = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

export const getMonthlyMealMenu = async (year, month) => {
  const response = await customerApi.get(
    `/getMonthlyMealMenu/${year}/${month}`,
    getAuthHeaders()
  );

  return response.data;
};

export const saveMonthlyMealMenuDay = async (data) => {
  const response = await customerApi.post(
    "/saveMonthlyMealMenuDay",
    data,
    getAuthHeaders()
  );

  return response.data;
};

export const deleteMonthlyMealMenuDay = async (data) => {
  const response = await customerApi.post(
    "/deleteMonthlyMealMenuDay",
    data,
    getAuthHeaders()
  );

  return response.data;
};

export const copyMonthlyMealMenu = async (data) => {
  const response = await customerApi.post(
    "/copyMonthlyMealMenu",
    data,
    getAuthHeaders()
  );

  return response.data;
};
